"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USAGE_NOT_SUPPORTED_BILLING_LINK = exports.USAGE_NOT_SUPPORTED_CALLOUT = exports.TOGGLE_FIELD_TOGGLE = exports.CHART_SHADOW = exports.CHART_SET = exports.USAGE_INFO_LINK = exports.USAGE_INFO = exports.USAGE_HELP_LINK = exports.USAGE_SEND_METER_READ = exports.USAGE_METER_READ_PROMPT = exports.USAGE_NO_CURRENT_DATA_INFO = exports.USAGE_MIXED_METER_INFO = exports.USAGE_MISSING_DATA_FOR_UNIT_WARNING = exports.USAGE_DATA_WARNING = exports.USAGE_TAB = exports.USAGE_NAVIGATION = exports.USAGE_COMPARISON_SELECT = exports.USAGE_SWITCH_VIEW_BUTTON = exports.USAGE_CONTROLS = exports.USAGE_PAGE = void 0;
exports.USAGE_PAGE = 'UsagePage';
exports.USAGE_CONTROLS = 'UsageControls';
exports.USAGE_SWITCH_VIEW_BUTTON = 'UsageSwitchViewButton';
exports.USAGE_COMPARISON_SELECT = 'UsageComparisonSelect';
exports.USAGE_NAVIGATION = 'UsageNavigation';
exports.USAGE_TAB = 'UsageTab';
exports.USAGE_DATA_WARNING = 'UsageDataWarning';
exports.USAGE_MISSING_DATA_FOR_UNIT_WARNING = 'UsageMissingDataForUnitWarning';
exports.USAGE_MIXED_METER_INFO = 'UsageMixedMeterInfo';
exports.USAGE_NO_CURRENT_DATA_INFO = 'UsageNoCurrentDataInfo';
exports.USAGE_METER_READ_PROMPT = 'UsageMeterReadPrompt';
exports.USAGE_SEND_METER_READ = 'UsageSendMeterRead';
exports.USAGE_HELP_LINK = 'UsageHelpLink';
exports.USAGE_INFO = 'UsageInfo';
exports.USAGE_INFO_LINK = 'UsageInfoLink';
exports.CHART_SET = 'ChartSet';
exports.CHART_SHADOW = 'ChartShadow';
exports.TOGGLE_FIELD_TOGGLE = 'ToggleFieldToggle';
exports.USAGE_NOT_SUPPORTED_CALLOUT = 'UsageNotSupportedCallout';
exports.USAGE_NOT_SUPPORTED_BILLING_LINK = 'UsageNotSupportedBillingLink';
